import * as $runtime from "../runtime.js";
import * as Control$dMonad$dRec$dClass from "../Control.Monad.Rec.Class/index.js";
import * as Control$dParallel from "../Control.Parallel/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Halogen$dAff$dDriver$dEval from "../Halogen.Aff.Driver.Eval/index.js";
import * as Halogen$dData$dSlot from "../Halogen.Data.Slot/index.js";
import * as Halogen$dQuery$dHalogenQ from "../Halogen.Query.HalogenQ/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dSubscription from "../Halogen.Subscription/index.js";
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect$dAff.applicativeAff)(Data$dList$dTypes.foldableList);
const traverse_1 = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect);
const traverse_2 = /* #__PURE__ */ traverse_1(Data$dFoldable.foldableMaybe);
const traverse_3 = /* #__PURE__ */ traverse_1(Data$dMap$dInternal.foldableMap);
const parSequence_ = /* #__PURE__ */ Control$dParallel.parTraverse_(Effect$dAff.parallelAff)(Effect$dAff.applicativeParAff)(Data$dList$dTypes.foldableList)(Control$dParallel.identity);
const foreachSlot = /* #__PURE__ */ Halogen$dData$dSlot.foreachSlot(Effect.applicativeEffect);
const renderStateX_ = /* #__PURE__ */ (() => {
  const traverse_$1 = Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
  return f => st => traverse_$1(f)(st.rendering);
})();
const newLifecycleHandlers = () => ({value: {initializers: Data$dList$dTypes.Nil, finalizers: Data$dList$dTypes.Nil}});
const handlePending = ref => () => {
  const queue = ref.value;
  ref.value = Data$dMaybe.Nothing;
  return for_(queue)((() => {
    const $0 = traverse_(Effect$dAff.forkAff);
    return x => Halogen$dAff$dDriver$dEval.handleAff($0((() => {
      const go = go$a0$copy => go$a1$copy => {
        let go$a0 = go$a0$copy, go$a1 = go$a1$copy, go$c = true, go$r;
        while (go$c) {
          const v = go$a0, v1 = go$a1;
          if (v1.tag === "Nil") {
            go$c = false;
            go$r = v;
            continue;
          }
          if (v1.tag === "Cons") {
            go$a0 = Data$dList$dTypes.$List("Cons", v1._1, v);
            go$a1 = v1._2;
            continue;
          }
          $runtime.fail();
        }
        return go$r;
      };
      return go(Data$dList$dTypes.Nil)(x);
    })()));
  })())();
};
const cleanupSubscriptionsAndForks = v => {
  const $0 = traverse_2(traverse_3(Halogen$dSubscription.unsubscribe));
  const $1 = v.subscriptions;
  return () => {
    const $2 = $1.value;
    $0($2)();
    v.subscriptions.value = Data$dMaybe.Nothing;
    const $3 = v.forks.value;
    traverse_3((() => {
      const $4 = Effect$dAff.killFiber(Effect$dException.error("finalized"));
      return x => Halogen$dAff$dDriver$dEval.handleAff($4(x));
    })())($3)();
    return v.forks.value = Data$dMap$dInternal.Leaf;
  };
};
const runUI = renderSpec => component => i => {
  const squashChildInitializers = lchs => preInits => st => {
    const parentInitializer = Halogen$dAff$dDriver$dEval.evalM(render)(st.selfRef)(st.component.eval(Halogen$dQuery$dHalogenQ.$HalogenQ("Initialize", undefined)));
    return () => {
      const $0 = lchs.value;
      lchs.value = {
        initializers: Data$dList$dTypes.$List(
          "Cons",
          Effect$dAff._bind(parSequence_((() => {
            const go = go$a0$copy => go$a1$copy => {
              let go$a0 = go$a0$copy, go$a1 = go$a1$copy, go$c = true, go$r;
              while (go$c) {
                const v = go$a0, v1 = go$a1;
                if (v1.tag === "Nil") {
                  go$c = false;
                  go$r = v;
                  continue;
                }
                if (v1.tag === "Cons") {
                  go$a0 = Data$dList$dTypes.$List("Cons", v1._1, v);
                  go$a1 = v1._2;
                  continue;
                }
                $runtime.fail();
              }
              return go$r;
            };
            return go(Data$dList$dTypes.Nil)($0.initializers);
          })()))(() => Effect$dAff._bind(parentInitializer)(() => Effect$dAff._liftEffect((() => {
            const $1 = handlePending(st.pendingQueries);
            return () => {
              $1();
              return handlePending(st.pendingOuts)();
            };
          })()))),
          preInits
        ),
        finalizers: $0.finalizers
      };
    };
  };
  const runComponent = lchs => handler => j => c => () => {
    const lchs$p = newLifecycleHandlers();
    const selfRef = {value: {}};
    const childrenIn = {value: Data$dMap$dInternal.Leaf};
    const childrenOut = {value: Data$dMap$dInternal.Leaf};
    const handlerRef = {value: handler};
    const pendingQueries = {value: Data$dMaybe.$Maybe("Just", Data$dList$dTypes.Nil)};
    const pendingOuts = {value: Data$dMaybe.$Maybe("Just", Data$dList$dTypes.Nil)};
    const pendingHandlers = {value: Data$dMaybe.Nothing};
    const fresh = {value: 1};
    const subscriptions = {value: Data$dMaybe.$Maybe("Just", Data$dMap$dInternal.Leaf)};
    const forks = {value: Data$dMap$dInternal.Leaf};
    selfRef.value = {
      component: c,
      state: c.initialState(j),
      refs: Data$dMap$dInternal.Leaf,
      children: Data$dMap$dInternal.Leaf,
      childrenIn,
      childrenOut,
      selfRef,
      handlerRef,
      pendingQueries,
      pendingOuts,
      pendingHandlers,
      rendering: Data$dMaybe.Nothing,
      fresh,
      subscriptions,
      forks,
      lifecycleHandlers: lchs$p
    };
    const pre = lchs.value;
    lchs.value = {initializers: Data$dList$dTypes.Nil, finalizers: pre.finalizers};
    const $0 = selfRef.value;
    render(lchs)($0.selfRef)();
    const $1 = selfRef.value;
    squashChildInitializers(lchs)(pre.initializers)($1)();
    return selfRef;
  };
  const renderChild = lchs => handler => childrenInRef => childrenOutRef => slot => () => {
    const a$p = childrenInRef.value;
    const childrenIn = slot.pop(a$p);
    const $$var = (() => {
      if (childrenIn.tag === "Just") {
        childrenInRef.value = childrenIn._1._2;
        const dsx = childrenIn._1._1.value;
        const $0 = Effect$dAff._pure();
        dsx.handlerRef.value = x => {
          const $1 = slot.output(x);
          if ($1.tag === "Nothing") { return $0; }
          if ($1.tag === "Just") { return handler($1._1); }
          $runtime.fail();
        };
        Halogen$dAff$dDriver$dEval.handleAff(Halogen$dAff$dDriver$dEval.evalM(render)(dsx.selfRef)(dsx.component.eval(Halogen$dQuery$dHalogenQ.$HalogenQ(
          "Receive",
          slot.input,
          undefined
        ))))();
        return childrenIn._1._1;
      }
      if (childrenIn.tag === "Nothing") {
        return runComponent(lchs)((() => {
          const $0 = Effect$dAff._pure();
          return x => {
            const $1 = slot.output(x);
            if ($1.tag === "Nothing") { return $0; }
            if ($1.tag === "Just") { return handler($1._1); }
            $runtime.fail();
          };
        })())(slot.input)(slot.component)();
      }
      $runtime.fail();
    })();
    const a$p$1 = childrenOutRef.value;
    const $0 = Effect$dConsole.warn("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur");
    if (
      (() => {
        const $1 = slot.get(a$p$1);
        if ($1.tag === "Nothing") { return false; }
        if ($1.tag === "Just") { return true; }
        $runtime.fail();
      })()
    ) {
      $0();
    }
    const $1 = childrenOutRef.value;
    childrenOutRef.value = slot.set($$var)($1);
    const $2 = $$var.value;
    if ($2.rendering.tag === "Nothing") { return Effect$dException.throwException(Effect$dException.error("Halogen internal error: child was not initialized in renderChild"))(); }
    if ($2.rendering.tag === "Just") { return renderSpec.renderChild($2.rendering._1); }
    $runtime.fail();
  };
  const render = lchs => $$var => () => {
    const v = $$var.value;
    const a$p = v.pendingHandlers.value;
    const shouldProcessHandlers = (() => {
      if (a$p.tag === "Nothing") { return true; }
      if (a$p.tag === "Just") { return false; }
      $runtime.fail();
    })();
    if (shouldProcessHandlers) { v.pendingHandlers.value = Data$dMaybe.$Maybe("Just", Data$dList$dTypes.Nil); }
    v.childrenOut.value = Data$dMap$dInternal.Leaf;
    v.childrenIn.value = v.children;
    const $0 = v.pendingHandlers;
    const rendering = renderSpec.render((() => {
      const $1 = Effect$dAff._map(v$1 => {});
      return x => Halogen$dAff$dDriver$dEval.handleAff(Halogen$dAff$dDriver$dEval.queueOrRun($0)($1(Halogen$dAff$dDriver$dEval.evalF(render)(v.selfRef)(x))));
    })())(renderChild(lchs)((() => {
      const $1 = Effect$dAff._map(v$1 => {});
      return x => Halogen$dAff$dDriver$dEval.queueOrRun(v.pendingQueries)(Halogen$dAff$dDriver$dEval.queueOrRun($0)($1(Halogen$dAff$dDriver$dEval.evalF(render)(v.selfRef)(Halogen$dQuery$dInput.$Input(
        "Action",
        x
      )))));
    })())(v.childrenIn)(v.childrenOut))(v.component.render(v.state))(v.rendering)();
    const children = v.childrenOut.value;
    const childrenIn = v.childrenIn.value;
    foreachSlot(childrenIn)(v1 => () => {
      const childDS = v1.value;
      renderStateX_(renderSpec.removeChild)(childDS)();
      return finalize(lchs)(childDS)();
    })();
    const $1 = v.selfRef.value;
    v.selfRef.value = {...$1, rendering: Data$dMaybe.$Maybe("Just", rendering), children};
    const $2 = Control$dMonad$dRec$dClass.monadRecEffect.tailRecM(v1 => () => {
      const handlers = $0.value;
      $0.value = Data$dMaybe.$Maybe("Just", Data$dList$dTypes.Nil);
      traverse_2((() => {
        const $2 = traverse_(Effect$dAff.forkAff);
        return x => Halogen$dAff$dDriver$dEval.handleAff($2((() => {
          const go = go$a0$copy => go$a1$copy => {
            let go$a0 = go$a0$copy, go$a1 = go$a1$copy, go$c = true, go$r;
            while (go$c) {
              const v$1 = go$a0, v1$1 = go$a1;
              if (v1$1.tag === "Nil") {
                go$c = false;
                go$r = v$1;
                continue;
              }
              if (v1$1.tag === "Cons") {
                go$a0 = Data$dList$dTypes.$List("Cons", v1$1._1, v$1);
                go$a1 = v1$1._2;
                continue;
              }
              $runtime.fail();
            }
            return go$r;
          };
          return go(Data$dList$dTypes.Nil)(x);
        })()));
      })())(handlers)();
      const mmore = $0.value;
      if (
        (() => {
          if (mmore.tag === "Nothing") { return false; }
          if (mmore.tag === "Just") { return mmore._1.tag === "Nil"; }
          $runtime.fail();
        })()
      ) {
        $0.value = Data$dMaybe.Nothing;
        return Control$dMonad$dRec$dClass.$Step("Done", undefined);
      }
      return Control$dMonad$dRec$dClass.$Step("Loop", undefined);
    })();
    if (shouldProcessHandlers) { return $2(); }
  };
  const finalize = lchs => st => {
    const $0 = cleanupSubscriptionsAndForks(st);
    return () => {
      $0();
      const $1 = lchs.value;
      lchs.value = {
        initializers: $1.initializers,
        finalizers: Data$dList$dTypes.$List(
          "Cons",
          Halogen$dAff$dDriver$dEval.evalM(render)(st.selfRef)(st.component.eval(Halogen$dQuery$dHalogenQ.$HalogenQ("Finalize", undefined))),
          $1.finalizers
        )
      };
      return foreachSlot(st.children)(v => () => {
        const dsx = v.value;
        return finalize(lchs)(dsx)();
      })();
    };
  };
  return Effect$dAff._bind(Effect$dAff._liftEffect(newLifecycleHandlers))(lchs => Effect$dAff._bind(Effect$dAff._liftEffect(() => ({value: false})))(disposed => Halogen$dAff$dDriver$dEval.handleLifecycle(lchs)(() => {
    const sio = Halogen$dSubscription.create();
    const $0 = runComponent(lchs)(x => Effect$dAff._liftEffect(sio.listener(x)))(i)(component)();
    const dsx = $0.value;
    return {
      query: (() => {
        const $1 = dsx.selfRef;
        return q => Effect$dAff._bind(Effect$dAff._liftEffect(() => disposed.value))(v => {
          if (v) { return Effect$dAff._pure(Data$dMaybe.Nothing); }
          return Halogen$dAff$dDriver$dEval.evalQ(render)($1)(q);
        });
      })(),
      messages: sio.emitter,
      dispose: Halogen$dAff$dDriver$dEval.handleLifecycle(lchs)(() => {
        const v = disposed.value;
        if (v) { return; }
        disposed.value = true;
        finalize(lchs)(dsx)();
        const v2 = dsx.selfRef.value;
        return for_(v2.rendering)(renderSpec.dispose)();
      })
    };
  })));
};
export {cleanupSubscriptionsAndForks, for_, foreachSlot, handlePending, newLifecycleHandlers, parSequence_, renderStateX_, runUI, traverse_, traverse_1, traverse_2, traverse_3};
